import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-mod-1',
    templateUrl: './mod-1.component.html'
})
export class Mod1Component implements OnInit {
    @Input() public pictures: any;

    constructor() {
    }

    ngOnInit() {
    }

    getImageByPosition(type) {
        for (let i = 0; i < this.pictures.length; i++) {
            if(this.pictures[i].position == type) {
                return this.pictures[i];
            }
        }
    }

}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/media/mod-1/mod-1.component.ts